import { useTranslation } from "react-i18next";
import audiophileImg from "../assets/images/audiophile.png";
import restcountriesImg from "../assets/images/restcountries.png";
import freshmartImg from "../assets/images/freshmart.png";
import anthonyportfolioImg from "../assets/images/anthonywaweru.png";
import easybankImg from "../assets/images/Easybanklandingpage.png";
import devfinderImg from "../assets/images/devfinder.png";
import sunnysideImg from "../assets/images/Sunnysideagencylandingpage.png";
import sneakersImg from "../assets/images/ecommerceproductpage.png";
import chatAppImg from "../assets/images/ChatAppwebsite.png";

// Hook to get translated project data
export const useTranslatedProjectData = () => {
  const { t } = useTranslation();

  return [
    {
      id: "audiophile",
      lead: t("projects.audiophile.lead"),
      title: t("projects.audiophile.title"),
      desc: t("projects.audiophile.description"),
      design: "Project",
      development: "React, Redux, Styled-Components, React-Router-Dom",
      concept: t("projects.audiophile.concept"),
      img: audiophileImg,
      link: "audiophile",
      live: true,
      demoUrl: "https://audiophile-ecommerce-navy.vercel.app/",
      githubUrl: "https://github.com/anthonynjeri/audiophile-ecommerce",
      features: t("projects.audiophile.features", { returnObjects: true }),
      techStack: ["React", "Redux", "Styled Components", "React Router"],
    },
    {
      id: "restcountries",
      lead: t("projects.restcountries.lead"),
      title: t("projects.restcountries.title"),
      desc: t("projects.restcountries.description"),
      design: "Project",
      development: "API, React, Tailwind-CSS, React-Router-Dom",
      concept: t("projects.restcountries.concept"),
      img: restcountriesImg,
      link: "restcountries",
      live: true,
      demoUrl: "https://rest-countries-api-three-blue.vercel.app/",
      githubUrl: "https://github.com/anthonynjeri/rest-countries",
      features: t("projects.restcountries.features", { returnObjects: true }),
      techStack: ["React", "Tailwind CSS", "REST API", "React Router"],
    },
    {
      id: "freshmart",
      lead: t("projects.freshmart.lead"),
      title: t("projects.freshmart.title"),
      desc: t("projects.freshmart.description"),
      design: "Project",
      development: "React/Styled-Components",
      concept: t("projects.freshmart.concept"),
      img: freshmartImg,
      link: "freshmart",
      live: true,
      demoUrl: "https://fresh-mart-omega.vercel.app/",
      githubUrl: "https://github.com/anthonynjeri/fresh-mart",
      features: t("projects.freshmart.features", { returnObjects: true }),
      techStack: ["React", "Styled Components", "Stripe API", "REST API"],
    },
    {
      id: "anthonyportfolio",
      lead: t("projects.anthonyportfolio.lead"),
      title: t("projects.anthonyportfolio.title"),
      desc: t("projects.anthonyportfolio.description"),
      design: "Website Design",
      development: "React/Styled-Components",
      concept: t("projects.anthonyportfolio.concept"),
      img: anthonyportfolioImg,
      link: "myportfolio",
      live: true,
      demoUrl: "https://www.anthonynjeri.com",
      githubUrl: "https://github.com/anthonynjeri/portfolio-v2",
      techStack: ["React", "Styled Components", "Framer Motion", "JavaScript"],
    },
    {
      id: "easybank",
      lead: t("projects.easybank.lead"),
      title: t("projects.easybank.title"),
      desc: t("projects.easybank.description"),
      design: "Figma Design",
      development: "HTML, SASS & Js Development",
      concept: t("projects.easybank.concept"),
      img: easybankImg,
      link: "easybank",
      demoUrl: "https://benevolent-griffin-d83450.netlify.app/",
      githubUrl: "https://github.com/anthonynjeri/easybank-landing-page",
      techStack: ["HTML", "SASS", "JavaScript", "Responsive Design"],
    },
    {
      id: "devfinder",
      lead: t("projects.devfinder.lead"),
      title: t("projects.devfinder.title"),
      desc: t("projects.devfinder.description"),
      design: "Figma",
      development: "HTML, SASS, API, Js",
      concept: t("projects.devfinder.concept"),
      img: devfinderImg,
      link: "devfinder",
      demoUrl: "https://scintillating-melomakarona-39ef86.netlify.app/",
      githubUrl: "https://github.com/anthonynjeri/github-user-search",
      techStack: ["HTML", "SASS", "JavaScript", "GitHub API"],
    },
    {
      id: "sunnyside",
      lead: t("projects.sunnyside.lead"),
      title: t("projects.sunnyside.title"),
      desc: t("projects.sunnyside.description"),
      design: "Figma Design",
      development: "HTML, CSS & Js Development",
      concept: t("projects.sunnyside.concept"),
      img: sunnysideImg,
      link: "sunnyside",
      demoUrl: "https://clinquant-crostata-4d246f.netlify.app/",
      githubUrl: "https://github.com/anthonynjeri/sunnyside-agency",
      techStack: ["HTML", "CSS", "JavaScript", "Responsive Design"],
    },
    {
      id: "sneakers",
      lead: t("projects.sneakers.lead"),
      title: t("projects.sneakers.title"),
      desc: t("projects.sneakers.description"),
      design: "Figma",
      development: "HTML, CSS & Js Development",
      concept: t("projects.sneakers.concept"),
      img: sneakersImg,
      link: "ecommerce",
      demoUrl: "https://zealous-edison-de12bb.netlify.app/",
      githubUrl: "https://github.com/anthonynjeri/ecommerce-product-page",
      techStack: ["HTML", "CSS", "JavaScript", "Responsive Design"],
    },
    {
      id: "chatapp",
      lead: t("projects.chatapp.lead"),
      title: t("projects.chatapp.title"),
      desc: t("projects.chatapp.description"),
      design: "Website Design",
      development: "Webflow Development",
      concept: t("projects.chatapp.concept"),
      img: chatAppImg,
      link: "chatapp",
      demoUrl: "https://chat-app-home-page-60f3d4.webflow.io/",
      techStack: ["Webflow", "CSS", "JavaScript", "Web Design"],
    },
  ];
};

// Hook to get translated page data
export const useTranslatedPageData = () => {
  const { t } = useTranslation();

  return [
    {
      id: "audiophile",
      lead: "Project Showcase",
      title: t("projects.audiophile.title"),
      description: t("projects.audiophile.pageDescription"),
      live: "https://audiophile-ecommerce-navy.vercel.app/",
      github: "https://github.com/anthonynjeri/audiophile-ecommerce",
      image: audiophileImg,
      techStack: ["React", "Redux", "JavaScript", "Styled Components"],
    },
    {
      id: "chatapp",
      lead: "Project Showcase",
      title: t("projects.chatapp.title"),
      description: t("projects.chatapp.pageDescription"),
      live: "https://chat-app-home-page-60f3d4.webflow.io/",
      github: null,
      image: chatAppImg,
      techStack: ["Webflow", "CSS", "JavaScript"],
    },
    {
      id: "devfinder",
      lead: "Project Showcase",
      title: t("projects.devfinder.title"),
      description: t("projects.devfinder.pageDescription"),
      live: "https://scintillating-melomakarona-39ef86.netlify.app/",
      github: "https://github.com/anthonynjeri/github-user-search",
      image: devfinderImg,
      techStack: ["JavaScript", "CSS", "GitHub API", "Responsive Design"],
    },
    {
      id: "easybank",
      lead: "Project Showcase",
      title: t("projects.easybank.title"),
      description: t("projects.easybank.pageDescription"),
      live: "https://benevolent-griffin-d83450.netlify.app/",
      github: "https://github.com/anthonynjeri/easybank-landing-page",
      image: easybankImg,
      techStack: ["HTML", "SASS", "JavaScript", "Responsive Design"],
    },
    {
      id: "sneakers",
      lead: "Project Showcase",
      title: t("projects.sneakers.title"),
      description: t("projects.sneakers.pageDescription"),
      live: "https://zealous-edison-de12bb.netlify.app/",
      github: "https://github.com/anthonynjeri/ecommerce-product-page",
      image: sneakersImg,
      techStack: ["HTML", "CSS", "JavaScript", "Responsive Design"],
    },
    {
      id: "freshmart",
      lead: "Project Showcase",
      title: t("projects.freshmart.title"),
      description: t("projects.freshmart.pageDescription"),
      live: "https://fresh-mart-omega.vercel.app/",
      github: "https://github.com/anthonynjeri/fresh-mart",
      image: freshmartImg,
      techStack: ["React", "JavaScript", "Stripe API", "REST API"],
    },
    {
      id: "restcountries",
      lead: "Project Showcase",
      title: t("projects.restcountries.title"),
      description: t("projects.restcountries.pageDescription"),
      live: "https://tiny-cat-0837cb.netlify.app/",
      github: "https://github.com/anthonynjeri/rest-countries",
      image: restcountriesImg,
      techStack: ["JavaScript", "CSS", "REST Countries API", "Local Storage"],
    },
    {
      id: "sunnyside",
      lead: "Project Showcase",
      title: t("projects.sunnyside.title"),
      description: t("projects.sunnyside.pageDescription"),
      live: "https://clinquant-crostata-4d246f.netlify.app/",
      github: "https://github.com/anthonynjeri/sunnyside-agency",
      image: sunnysideImg,
      techStack: ["HTML", "CSS", "JavaScript", "Responsive Design"],
    },
    {
      id: "anthonyportfolio",
      lead: "Project Showcase",
      title: t("projects.anthonyportfolio.title"),
      description: t("projects.anthonyportfolio.pageDescription"),
      live: "https://www.anthonynjeri.com",
      github: "https://github.com/anthonynjeri/portfolio-v2",
      image: anthonyportfolioImg,
      techStack: ["React", "Styled Components", "Figma", "Framer Motion"],
    },
  ];
};
